import ReminderTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/ReminderService/ReminderTranslationResponse';

export default class ReminderUpdateRequest  {
	ReminderId: number = 0;
	Translations: Array<ReminderTranslationResponse> = null;
	constructor(obj?: Partial<ReminderUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
